import apiClient from './apiClient';
import {NoticeType} from "../types/NoticeType";

const fetchNoticeAPI = async () : Promise<NoticeType[]> => {
	const response = await apiClient.get('/api/public/system/notice/list');
	return response.data;
}

const writeNoticeAPI = async (title: string, content: string) : Promise<NoticeType[]> => {
	const response = await apiClient.post('/api/admin/common/notice', {
		title, content,
	});
	return response.data;
}

const editNoticeAPI = async (id: string, title: string, content: string) : Promise<NoticeType[]> => {
	const response = await apiClient.put(`/api/admin/common/notice/${id}`, {
		title, content,
	});
	return response.data;
}

const deleteNoticeAPI = async (id: string) : Promise<NoticeType[]> => {
	const response = await apiClient.delete(`/api/admin/common/notice/${id}`);
	return response.data;
}


const noticeAPI = {
	fetchNoticeAPI,
	writeNoticeAPI,
	editNoticeAPI,
	deleteNoticeAPI,
}

export default noticeAPI;

